export default "__VITE_ASSET__DgBpsyrK__"